import { useLiveQuery } from 'dexie-react-hooks';
import { buyerLedger, type BuyerLedger, type DomainPayment, type DomainSale } from '@dairy/domain';
import type { BuyerRecord, PaymentRecord, SaleRecord } from '@dairy/shared';
import { useSettings } from '@/auth/useSession';
import { db } from '@/db/db';
import { useToday } from '@/db/hooks';

export interface BuyerWithLedger {
  buyer: BuyerRecord;
  ledger: BuyerLedger;
  sales: SaleRecord[];
  payments: PaymentRecord[];
}

/** IN-4: every buyer with balance, unpaid sales (FIFO), ages and buckets (D-9), as of today. */
export function useBuyerLedgers(): BuyerWithLedger[] | undefined {
  const s = useSettings();
  const today = useToday();
  return useLiveQuery(async () => {
    const [buyers, sales, payments] = await Promise.all([db.buyers.toArray(), db.sales.toArray(), db.payments.toArray()]);
    return buyers
      .map((buyer) => {
        const bs = sales.filter((x) => x.buyerId === buyer.id);
        const bp = payments.filter((x) => x.buyerId === buyer.id);
        return {
          buyer,
          sales: bs,
          payments: bp,
          ledger: buyerLedger(bs as unknown as DomainSale[], bp as unknown as DomainPayment[], today, s.receivableOverdueDays),
        };
      })
      .sort((a, b) => a.buyer.name.localeCompare(b.buyer.name));
  }, [today, s.receivableOverdueDays]);
}
